// ============================================================================
// view.layers — the Layer Groups directory, read and written locally
// ============================================================================
//
// /layer/groups renders from the ppp-layer-groups-v1 blob, the layer batch and
// housing directories, and a recent daily-report window. layer.groups.core owns
// all four reads. The only former legacy dependency was the write callback App
// threaded through LayerEntry.
//
// That callback was three things: a ppp-layer-groups-v1 upsert, a
// LayerContext mirror publish, and an opportunistic maintenance pass. The page
// now owns the first two without recreating App logic:
//
//   * src/lib/appStoreBlobApi.ts is App's own three-attempt / 8s timeout /
//     Saving-Saved-Error transport behavior, so LayersView calls the same seam
//     with the same Supabase client and AuthContext status sink.
//   * LayersView publishes setLayerGroups(next), but it never reads that value.
//     The setter keeps App's still-legacy feed-cost fan-out current; a setter is
//     not a boot dependency or a render input.
//
// The third responsibility is intentionally NOT copied into the route. The
// session-free maintenance-cron service reloads stored sources and publishes the
// six derived webform_config mirrors. A released surface cannot hold App's
// legacy all-data claim, so preserving the old nested triggerMaintenance call
// would be impossible as well as the wrong ownership boundary.
//
// This declaration therefore says only what the code proves: every Layer Groups
// render input has a permanent owner, and its save no longer depends on legacy
// boot or an App callback. A separate release ledger row authorizes the bypass.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.layers',
  obligations: Object.freeze([Object.freeze({id: 'layer.groups.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([] as const),
});

export default declaration;
